export const compTypesWithNativeMappers = {
	AddressInput: true,
	AppWidget: true,
	BackgroundGroup: true,
	BackToTopButton: true,
	Checkbox: true,
	CheckboxGroup: true,
	ComboBoxInput: true,
	ComboBoxInputListModal: true,
	DatePicker: true,
	FacebookLikeBox: true,
	FileUploader: true,
	FiveGridLine: true,
	ItunesButton: true,
	LanguageSelector: true,
	LinkBar: true,
	LoginSocialBar: true,
	PaginatedGridGallery: true,
	Pagination: true,
	PopupCloseIconButton: true,
	RadioGroup: true,
	RatingsDisplay: true,
	RatingsInput: true,
	ResponsivePopupPage: true,
	SignatureInput: true,
	SiteButton: true,
}
